<template>
    
    <div 
            class="single-news flex-col"
           
            >
                <div class="single-news__image">
                   <a :href="dataPost.link" 
                      :title="dataPost.title.rendered"
                   >   
                      <picture-news :featured="`${dataPost.featured_media}`" />
                </a>
                    </div>
                <div class="single-news__title pt-8 pb-12 border-b border-white ">
                    <a :href="dataPost.link">
                        <h3 class="text-white text-2.6rem h-32" v-html="dataPost.title.rendered"></h3>
                    </a>
                </div>
                <div class="single-news__desc text-1.8rem pt-8" v-html="truncate(dataPost.content.rendered,25, `<a href='${dataPost.link}' class='font-bold'> ...READ MORE</a>`)"></div>
            </div>
   
</template>

<script>
    export default {
       name:'post-news', 
       props:{
        dataPost:{
            type:Object,
            default: () =>{}
        }
       },
       methods:{
       truncate (text, limit, append) {
    if (typeof text !== 'string')
        return '';
    if (typeof append == 'undefined')
        append = '...';
    var parts = text.split(' ');
    if (parts.length > limit) {
        // loop backward through the string
        for (var i = parts.length - 1; i > -1; --i) {
            // if i is over limit, drop this word from the array
            if (i+1 > limit) {
                parts.length = i;
            }
        }
        // add the truncate append text
        
       
    }
    // join the array back into a string
    return parts.join(' ').replace(/<\/?[^>]+(>|$)/g, "")+` ${append} `
}
    }
    }
</script>

<style lang="scss" scoped>
.modal-enter-active,
.modal-leave-active { transition: opacity 350ms }

.modal-enter,
.modal-leave-to { opacity: 0 }

.modal-leave,
.modal-enter-to { opacity: 1 }
</style>